import SettingsFormInput from './settings-form-input'
import SettingsFormButton from './settings-form-button'
import SettingsSwitcher from './settings-switcher'

const requires = {
    SettingsFormInput,
    SettingsFormButton,
    SettingsSwitcher
}

export default requires